<template>
  <div>
    <v-snackbar
        v-model="snackbar.error"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.errorMessage }}
    </v-snackbar>
    <v-snackbar
        v-model="snackbar.success"
        color="success"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.successMessage }}
    </v-snackbar>

    <v-dialog v-model="showUpdateCcDialog" persistent>
      <LoadingDialog v-model="showLoadingDialog" />
      <v-card class="pa-3">
        <v-card-title class="pb-1 pt-0">
          <h2>Update Payment Info</h2>
          <v-spacer />
          <v-btn flat icon color="itoviGrayMid" @click="close()"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text v-if="this.isExpired()">
          Your card is expired, please update card info to <b>reactivate your account</b>
        </v-card-text>
        <v-card-text v-else-if="this.isExpiringSoon()">
          Your card will expire soon, please update card info.
        </v-card-text>
        <v-card-text class="pt-1">
          <v-container grid-list-md class="pa-0">
            <v-layout wrap>
              <v-form
                  ref="addCcForm"
                  v-model="addCcData.addCcFormValid"
                  lazy-validation
              >
                <!-- this hidden element is just to take focus for the validation (so it doesn't fire early)-->
                <v-text-field class="d-none" />

                <v-flex xs12>
                  <v-text-field :rules="[checkForErrors('name_on_card')]" v-model="addCcData.name" label="Name on card"/>
                </v-flex>
                <v-flex xs12>
                  <v-text-field :rules="[checkForErrors('cc_number')]" mask="credit-card" v-model="addCcData.cardNumber" label="Card Number"/>
                </v-flex>
                <v-layout row wrap xs12>
                  <v-flex xs5 md4>
                    <v-text-field :rules="[checkForErrors('cc_cvc')]" mask="####" v-model="addCcData.securityCode" label="Security Code" type="text"/>
                  </v-flex>
                  <v-flex xs1 />
                  <v-flex xs6 md4>
                    <v-text-field v-model="addCcData.zip" label="Billing Zip" type="text"/>
                  </v-flex>
                </v-layout>

                <v-flex xs12 >

                  <v-layout row class="pt-2">
                    <b>Expiration:</b>
                  </v-layout>

                  <v-layout row>
                    <v-flex xs6 md3>
                      <v-select
                          :rules="[checkForErrors('cc_exp_month')]"
                          v-model="addCcData.expMonth"
                          :items="ccExpirationMonths"
                          label="Month"
                          required
                      />
                    </v-flex>
                    <v-flex xs6 md3>
                      <v-select
                          :rules="[checkForErrors('cc_exp_year')]"
                          v-model="addCcData.expYear"
                          :items="ccExpirationYears"
                          label="Year"
                          required
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-form>
            </v-layout>
          </v-container>
        </v-card-text>
<!--        <v-card-text v-if="declinedPayment && planDetails">-->
<!--          *Your card will be charged <b>${{planDetails.price}}</b>-->
<!--        </v-card-text>-->
        <v-card-actions class="mt-2">
          <v-spacer />
          <button class="button-blue-outline" @click="close()">Cancel</button>
          <button :disabled="showLoadingDialog" class="button-blue ml-3" @click="submitCreditCardUpdate()">
            Save
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import LoadingDialog from "../../LoadingDialog"
  import api from "../../../services/api_endpoints"
  import moment from "moment"
  import store from "@/store";
  import subscribeToStore from "@/mixins/subscribeToStore";
  import ccHelper from "@/mixins/ccHelper";

  export default {
    components: {
      LoadingDialog
    },
    data: ()=> ({
      declinedPayment: store.state.declinedPayment,
      showUpdateCcDialog: store.state.showUpdateCcDialog,
      showLoadingDialog: false,
      ccInfo: store.state.ccInfo,
      planDetails: store.state.planDetails,
      addCcData: {
        name: '',
        cardNumber: '',
        securityCode: '',
        zip: '',
        expMonth: '',
        expYear: '',
        addCcFormValid: false,
        showDialog: false,
      },
      ccExpirationMonths: Array.from(Array(12).keys()).map(x => 1 + x),
      ccExpirationYears: Array.from(Array(50).keys()).map(x => 2019 + x),
      snackbar: {
        success: false,
        error: false,
        timeout: 5000,
        errorMessage: "An unknown error occurred",
        successMessage: "Credit card updated successfully"
      },
      errors: {}
    }),
    props: {
      value: Boolean
    },
    mixins: [subscribeToStore, ccHelper],
    mounted() {
      this.subscribeToStore(['showUpdateCcDialog', 'declinedPayment', 'planDetails'])
    },
    methods: {
      close() {
        this.$refs.addCcForm.reset();
        store.commit('setShowUpdateCcDialog', false);
      },
      moment: function (dateString, format) {
        return moment(dateString,format);
      },
      checkForErrors(name) {
        return this.errors[name] ? this.errors[name][0] : true;
      },
      async submitCreditCardUpdate(payNow = false) {
        this.errors = {};
        if (this.showLoadingDialog === true) return;
        this.showLoadingDialog = true;
        let successMessage = "You card has been updated!";
        let response = await api.submitCcChange({
          name_on_card: `${this.addCcData.name}`,
          cc_cvc: `${this.addCcData.securityCode}`,
          cc_exp_month: `${this.addCcData.expMonth < 10 ? '0' : ''}${this.addCcData.expMonth}`,
          cc_exp_year: `${this.addCcData.expYear}`,
          cc_number: `${this.addCcData.cardNumber}`
        });

        console.log(response.success);

        if (!response.success) {
          this.errors = response.errors;
          if (!this.$refs.addCcForm.validate()) return;
          this.snackbar = {...this.snackbar, error: true, errorMessage: "Error updating card info."};
          this.showLoadingDialog = false;
          return;
        }

        if (payNow) {
          const result = await api.reActivateAccount();
          if (!result.success) {
            this.snackbar = {...this.snackbar, error: true, errorMessage: result.errors.length ? result.errors[0].errorText : "Unable to activate account."};
            this.showLoadingDialog = false;
            return;
          }
          await api.refreshDashboard();
          successMessage = `${this.planDetails.name} was successfully activated on your account!`;
        }
        store.commit('setShowSuccessDialog', { active: true, message: successMessage });
        this.showLoadingDialog = false;
        this.close();
      },
    }
  }
</script>
